<xemex-dialog-shell [title]="'deleteUser.title' | translate">
  <div class="p-2">
    @if (deleteCurrentUser) {
      <span>{{ 'deleteUser.deleteCurrentUserText' | translate }}</span>
    } @else if (userDeletedSuccess) {
      <span>{{ 'deleteUser.successText' | translate }}</span>
    } @else if (userDeletedError) {
      <span>{{ 'deleteUser.errorText' | translate }}</span>
    } @else {
      <span>{{ 'deleteUser.confirmationText' | translate }}</span>
    }
  </div>
  <mat-dialog-actions actions>
    @if (!deleteCurrentUser && !userDeletedError && !userDeletedSuccess) {
      <xemex-filled-button intent="destructive" (click)="onDelete()" [disabled]="isDeleting">
        <div class="flex">
          <span class="mr-2">{{ 'general.btnDelete' | translate }}</span>
          @if (isDeleting) {
            <xemex-spinner size="sm"></xemex-spinner>
          }
        </div>
      </xemex-filled-button>
    }
    @if (!userDeletedError && !userDeletedSuccess) {
      <xemex-outlined-button mat-dialog-close type="button">
        {{ 'general.btnCancel' | translate }}
      </xemex-outlined-button>
    } @else {
      <xemex-filled-button mat-dialog-close class="float-right">
        {{ 'general.btnClose' | translate }}
      </xemex-filled-button>
    }
  </mat-dialog-actions>
</xemex-dialog-shell>
